// State object
import axios from '../../axios-instance'
import _ from 'lodash'

const state = {
  currentCustomer: { data: null, error: null },
  allSubscriptions: { data: null, error: null },
  allUsersWithSubscription: { data: null, error: null },
  allInvitations: { data: null, error: null },
  invitationsPollingInterval: null,
  usersPollingInterval: null
}

// Getter functions
const getters = {
}

// Mutations
const mutations = {
  setCurrentCustomer: function (state, customer) {
    state.currentCustomer = customer
  },
  setCurrentCustomerError: function (state, customer) {
    state.currentCustomer.error = customer
  },
  setAllUsersWithSubscription: function (state, users) {
    state.allUsersWithSubscription = users
  },
  setAllUsersWithSubscriptionError: function (state, error) {
    state.allUsersWithSubscription.error = error
  },
  setAllSubscriptions: function (state, subscriptions) {
    state.allSubscriptions = subscriptions
  },
  setAllSubscriptionsError: function (state, error) {
    state.allSubscriptions.error = error
  },
  setAllInvitations: function (state, invitations) {
    state.allInvitations = invitations
  },
  setAllInvitationsError: function (state, error) {
    state.allInvitations.error = error
  },
  removeInvitation: function (state, id) {
    let invitationIndex = state.allInvitations.data.findIndex(function (invite) {
      return invite.id === id
    })
    if (invitationIndex !== -1) {
      state.allInvitations.data.splice(invitationIndex, 1)
    }
  },

  setInvitationsPollingInterval: function (state, intervalFunction) {
    state.invitationsPollingInterval = setInterval(intervalFunction, parseInt(process.env.VUE_APP_PI_INVITATIONS))
  },

  clearInvitationsPollingInterval: function (state) {
    clearInterval(state.invitationsPollingInterval)
    state.invitationsPollingInterval = null
  },

  setUsersPollingInterval: function (state, intervalFunction) {
    state.usersPollingInterval = setInterval(intervalFunction, parseInt(process.env.VUE_APP_PI_USERS))
  },

  clearUsersPollingInterval: function (state) {
    clearInterval(state.usersPollingInterval)
    state.usersPollingInterval = null
  }
}

// Actions
const actions = {
  /* -------FETCH-------- */
  fetchCustomer: function (context, id) {
    return new Promise((resolve, reject) => {
      setTimeout(function () {
        let customer = {
          id: parseInt(id),
          name: 'Naboen Avdeling Oslo'
        }
        context.commit('setCurrentCustomer', { data: customer, error: null })
        resolve()
      }, 500)
    })
  },

  fetchAllUsersWithSubscription: function (context) {
    axios({
      method: 'get',
      url: '/customers/' + context.state.currentCustomer.data.id + '/subscriptionusers'
    })
      .then(response => {
        context.commit('setAllUsersWithSubscription', { data: response.data, error: null })
      })
      .catch(error => {
        context.commit('setAllUsersWithSubscriptionError', error.message)
      })
  },

  fetchAllSubscriptions: function (context) {
    axios({
      method: 'get',
      url: '/customers/' + context.state.currentCustomer.data.id + '/subscriptions'
    })
      .then(response => {
        context.commit('setAllSubscriptions', { data: response.data, error: null })
      })
      .catch(error => {
        context.commit('setAllSubscriptionsError', error.message)
      })
  },
  fetchAllInvitations: function (context) {
    axios({
      method: 'get',
      url: '/customers/' + context.state.currentCustomer.data.id + '/subscriptioninvitations'
    })
      .then(response => {
        context.commit('setAllInvitations', { data: response.data, error: null })
      })
      .catch(error => {
        context.commit('setAllInvitationsError', error.message)
      })
  },
  /* -------SAVE-------- */
  // api/invitiations/id/create (payload = email and subscriptionId, return value = invite)
  createInvitation: function (context, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/invitations',
        data: {
          email: payload.email,
          subscriptions: payload.subscriptionIds,
          owner: context.state.currentCustomer.data.id
        }
      })
        .then(response => {
          context.dispatch('updateInvitations', response.data)
          resolve(response.data)
        })
        .catch(error => {
          let extendedError = payload.email + ': ' + error.message
          reject(extendedError)
        })
    })
  },
  resendInvitation: function (context, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/invitations/' + payload.id + '/resend'
      })
        .then(response => {
          context.commit('setSuccessMessage', 'Invite sent successfully', { root: true })
          resolve(response)
        })
        .catch(error => {
          context.commit('setErrorMessages', error.message, { root: true })
          reject(error.message)
        })
    })
  },
  /* -------DELETE-------- */
  deleteInvitation: function (context, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: '/invitations/' + payload.id
      })
        .then(response => {
          context.commit('removeInvitation', payload.id)
          resolve()
        })
        .catch(error => {
          context.commit('setErrorMessages', error.message, { root: true })
          reject(error.message)
        })
    })
  },

  deleteInvitationSubscription: function (context, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: '/invitations/' + payload.invitation.id + '/subscriptions/' + payload.subscription.id
      })
        .then(response => {
          context.dispatch('removeInvitationSubscriptions', payload)
          context.commit('setSuccessMessage', 'Device ' + payload.subscription.unit.alias + ' removed from ' + payload.invitation.email + ' invitation', { root: true })
          resolve(response.data)
        })
        .catch(error => {
          context.commit('setErrorMessages', error.message, { root: true })
          reject(error.message)
        })
    })
  },
  /* -------RESET-------- */
  resetCurrentCustomerData: function (context) {
    context.commit('setAllInvitations', { data: null, error: null })
    context.commit('setAllSubscriptions', { data: null, error: null })
    context.commit('setAllUsersWithSubscription', { data: null, error: null })
    context.commit('clearInvitationsPollingInterval')
    context.commit('clearUsersPollingInterval')
  },

  /* -------OTHER-------- */
  setCurrentCustomerById: function (context, id) {
    let newCustomer = context.rootState.customers.data.find(function (customer) {
      return customer.id === id
    })
    if (newCustomer !== undefined) {
      context.commit('setCurrentCustomer', { data: newCustomer, error: null })
    } else {
      context.commit('setCurrentCustomerError', 'You do not have access to this customer. Choose a customer from the list above.')
    }
  },
  updateInvitations: function (context, invitation) {
    let existingInvite = context.state.allInvitations.data.find(function (invite) {
      return invite.id === invitation.id
    })
    if (existingInvite !== undefined) {
      existingInvite.subscriptions = _.unionBy(invitation.subscriptions, existingInvite.subscriptions, 'id')
    } else {
      context.state.allInvitations.data.push(invitation)
    }
  },

  removeInvitationSubscriptions: function (context, payload) {
    let invitationIndex = context.state.allInvitations.data.findIndex(function (invite) {
      return invite.id === payload.invitation.id
    })
    if (invitationIndex >= 0) {
      let invitation = context.state.allInvitations.data[invitationIndex]
      let subscriptionIndex = invitation.subscriptions.findIndex(function (subscription) {
        return subscription.id === payload.subscription.id
      })
      if (subscriptionIndex >= 0) {
        invitation.subscriptions.splice(subscriptionIndex, 1)
        if (invitation.subscriptions.length === 0) {
          context.state.allInvitations.data.splice(invitationIndex, 1)
        }
      }
    }
  },

  startPollInvitations: function (context) {
    if (context.state.invitationsPollingInterval === null) {
      context.commit('setInvitationsPollingInterval', function () { context.dispatch('fetchAllInvitations') })
    }
  },

  stopPolInvitations: function (context) {
    context.commit('clearInvitationsPollingInterval')
  },

  startPollUsers: function (context) {
    if (context.state.usersPollingInterval === null) {
      context.commit('setUsersPollingInterval', function () { context.dispatch('fetchAllUsersWithSubscription') })
    }
  },

  stopPollUsers: function (context) {
    context.commit('clearUsersPollingInterval')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
